const calendarStyledCompCalendar = {
  culture: 'es'
};

export default calendarStyledCompCalendar